<template>
  <div id="app">
      <!-- Navbar -->
      <HeaderNav></HeaderNav>

      <!-- Render the routes -->
      <router-view class="pt-32" style="min-height:80vh"></router-view>

      <!-- Footer code -->
      <appFooter></appFooter>
  </div>
</template>

<script>

import HeaderNav from './components/headerNav.vue'
import appFooter from './components/footer'

export default {
  name: 'app',
  components: {
    HeaderNav,
    appFooter
  }
}
</script>


<style>
#app {
  /*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;*/
  /*margin-top: 60px;*/
}

.modal .modal-content {
  background: white;
  border-radius: 5px;
  padding: 30px 40px;
  max-width: 400px;
}

.modal .modal-content form {
  margin-top: 20px;
}

.modal .modal-content form input {
  box-shadow: none;
  border: 0;
  background-color: #f3f3f3; 
}

</style>
